import styled from 'styled-components'
import Scrollbars from 'react-custom-scrollbars'
import DOMPurify from 'dompurify'

export const ServiceAgreement = props => {
  const { data, service } = props
  return (
    <ListContainer>
      <LoginContainer>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(service) }} />
        {/* <div className="text">
          欢迎您使用矢安科技提供的产品/服务。本协议系由您与上海矢安科技有限矢安科技（以下简称“矢安科技”或“我们”）共同签署，并于您在终端设备（如电脑、手机等）使用矢安科技提供的产品/服务之时生效。
        </div>
        <div className="text">
          在您完成注册程序前，请您务必仔细阅读并透彻理解矢安科技的服务条款（以下简称“本协议”），特别是限制或免除责任的条款、隐私保护政策、帐号规则、法律适用和争议解决条款（包括管辖条款）。以及其它以加粗
          加黑和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。如您对本协议内容有疑问或不同意本协议内容，请您停止下一步操作。
        </div>
        <div className="text">
          由于产品与服务更新，您与矢安科技签署的本协议列明的条款并不能完整罗列并覆盖您与矢安科技所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，为了更全面地界定您与矢安科技之间的权利义务，
          矢安科技隐私政策、规则、公告声明等则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用矢安科技服务，视为您同意上述补充协议。
        </div>
        <div className="text">
          请注意，当您试用、使用矢安科技提供的产品/服务，表示您已阅读并接受本协议及隐私政策等的所有条款。本协议在您使用矢安科技提供的产品/服务的整个过程中有效，如果您不同意本协议，您应立即停止使用矢安科技
          提供的产品/服务。
        </div>
        <div className="title">一、账户注册资格</div>
        <ul>
          <li>
            1.1
            您确认，在您完成注册程序时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人、政府机构或者其他组织。
          </li>
          <li>
            1.2
            如您为无民事行为能力人或为限制民事行为能力人，请告知您的监护人，并在您监护人的指导下阅读本协议和使用矢安科技提供的产品/服务。若您非中华人民共和国境内（为本协议之目的，不包括香港、澳门特别行政区及台湾地区）用户，您还需同时遵守您所属国家或地区的法律，且您确认，订立并履行本协议不违反您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规。
          </li>
          <li>
            1.3
            此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用矢安科技的相关服务，同时您理解违反前述要求可能会造成您无法正常注册及使用矢安科技的相关产品/服务。
          </li>
        </ul>
        <div className="title">二、账户注册</div>
        <ul>
          <li>
            2.1
            如您需试用或使用矢安科技的产品/服务，需在网站和/或小程序、APP等完成注册，成为矢安科技用户。
          </li>
          <li>
            2.2
            您在注册成为矢安科技用户前，须仔细阅读本协议全部内容，并点击“我已阅读并同意《矢安科技服务协议》《矢安科技隐私政策》”完成注册。
          </li>
          <li>
            2.3
            您点击确认“我已阅读并同意《矢安科技服务协议》《矢安科技隐私政策》”按钮，即表示您完全接受本协议的全部条款，本协议自您点击确认“我已阅读并同意《矢安科技服务协议》《矢安科技隐私政策》”按钮之时成立并生效。
          </li>
          <li>
            2.4
            您注册之时，需要依照提示提供如下信息：姓名、手机号码、电子邮箱以及产品/服务要求提供的其他信息，以便矢安科技与您联系。您了解并同意，您有义务保持您提供信息的真实性、合法性及有效性。若您提供任何违法、不道德或矢安科技认为不适合展示的资料，矢安科技有权拒绝您的注册、暂停或终止您的账户，并禁止您于现在和未来使用矢安科技之全部或部分服务。
          </li>
          <li>
            2.5
            您按照矢安科技操作指引完成注册后即成为矢安科技注册用户，矢安科技将根据您填写的注册信息与您联系，在您同意的前提下为您建立客户档案、推荐产品/服务并提供产品试用账号用于登录客户平台，作为您试用矢安科技所展示产品/服务的凭证。
          </li>
        </ul>
        <div className="title">三、账户的使用</div>
        <ul>
          <li>
            3.1
            您应妥善保管您的账户资料、产品试用账号，避免账户资料、产品试用账号发生遗失、外泄等情况，且账户、账号等不可转让、转借、抵押、质押等。因您的账户资料、试用账号遗失、外泄或者转让、转借、抵押、质押等情形造成的一切责任均由您独自承担，矢安科技不承担任何责任。如果矢安科技发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，矢安科技有权立即暂停或终止向该注册账号提供服务，或注销该账号。
          </li>
          <li>
            3.2
            您对您注册的矢安科技账户、试用账号及密码进行的一切操作负完全的责任，且您同意对您的帐号和密码进行妥善保管，对于因密码泄露所致的损失，由您自行承担。如您发现有他人冒用或盗用您的帐号及密码或任何其他未经合法授权之情形时，应立即以有效方式通知矢安科技，要求矢安科技暂停相关服务。同时，您理解矢安科技对其的请求采取行动需要合理期限，在矢安科技采取措施前，矢安科技对已执行的指令及所导致的您的损失不承担任何责任。
          </li>
        </ul>
        <div className="title">四、账户的注销</div>
        <div className="second-title">
          在需要终止使用矢安科技提供的服务时，符合以下条件的，您可以申请注销您的账户：
        </div>
        <ul>
          <li>4.1 您仅能申请注销您本人的账户，并依照矢安科技的流程进行注销。</li>
          <li>
            4.2
            您申请注销的账户处于正常状态，即您的账户的信息时最新、完整、正确的，且账户未被采取冻结等限制措施。
          </li>
          <li>
            4.3
            为了维护您和其他用户的合法利益，您申请注销的账户，应当不存在未了结的权利义务或其他因为注销该账户会产生纠纷的情况。
          </li>
          <li>
            4.4
            您理解并同意，如您连续12个月未通过账户登录，且您的账户下不存在任何未到期的服务，矢安科技有权注销您的账户，您将不能再登录使用账户。
          </li>
          <li className="second-title ">
            4.5
            账户注销后，您将无法继续使用矢安科技提供的相应服务，双方的权利义务终止，同时还可能产生如下后果：
          </li>
          <li className="directory">
            4.5.1 如您在注销账户前存在违约、侵权等不当行为的，您仍应承担相应责任；
          </li>
          <li className="directory">
            4.5.2 一旦注销成功，账户记录、账户功能等将无法恢复或提供。 五、产品/服务的使用规范
          </li>
        </ul>
        <div className="title">五、产品/服务的使用规范</div>
        <ul>
          <li>
            5.1
            您有权使用矢安科技为您分配的账号登录矢安科技提供的客户平台并试用、使用矢安科技提供的产品/服务。您理解并同意，如您试用或使用矢安科技提供的产品/服务，矢安科技可能会根据产品/服务的情况与您另行签订单项协议。
          </li>
          <li>
            5.2
            您试用、使用矢安科技提供的产品/服务之时，需要遵守中华人民共和国相关法律法规及您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规，不得将矢安科技提供的产品/服务用于非法目的（包括用于禁止或限制交易物品的交易），也不得以非法方式使用矢安科技提供的产品/服务。
          </li>
          <li>
            5.3
            您不得利用矢安科技提供的产品/服务从事侵犯国家利益和社会公共利益、侵害他人合法权益之行为或违反国家法律法规，否则矢安科技有权进行调查、延迟或停止为您提供服务，且您需要自行承担相关法律责任，如因此导致矢安科技或其他方受损的，您需要承担赔偿责任。
          </li>

          <li className="second-title ">5.4 上述5.2和5.3适用的情况包括但不限于：</li>
          <li className="directory">
            5.4.1 侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益；
          </li>
          <li className="directory">5.4.2 违反保密义务；</li>
          <li className="directory">5.4.3 冒用他人名义使用矢安科技提供的产品/服务；</li>
          <li className="directory">
            5.4.4
            使用任何插件、外挂、系统或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响；
          </li>
          <li className="directory">5.4.5 利用或针对本服务进行任何危害计算机网络安全的行为；</li>
          <li className="directory">
            5.4.6
            发布的任何文字、图片、短视频、GIF动图等信息、资讯、评论等存在反对宪法确定的基本原则；危害国家安全、泄露国家秘密；颠覆国家政权，推翻社会主义制度；煽动分裂国家，破坏国家统一，损害国家荣誉和利益；宣扬恐怖主义、极端主义；宣扬民族仇恨、民族歧视，破坏民族团结；煽动地域歧视、地域仇恨；破坏国家宗教政策，宣扬邪教和迷信；编造、散布谣言、虚假信息；散布、传播暴力、淫秽、色情、赌博、凶杀、恐怖或者教唆犯罪；侵害未成年人合法权益或者损害未成年人身心健康；未获他人允许，偷拍、偷录他人，侵害他人合法权利；包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容；对他人进行暴力恐吓、威胁，实施人肉搜索；等等违反宪法、法律、法规、破坏公共秩序与社会公德、损害社会主义制度、国家利益和公序良俗的情形；
          </li>
          <li className="directory">5.4.7 从事可能侵害矢安科技的服务系统、数据的行为；</li>
          <li className="directory">5.4.8 其他违反法律、法规规定的行为。</li>
          <li>
            5.5
            您理解，矢安科技提供的产品/服务有赖于系统的准确运行及操作。若出现系统差错、故障、您或矢安科技不当获利等情形，您同意矢安科技可以采取更正差错等适当纠正措施。
          </li>
          <li>
            5.6
            您不得对矢安科技的系统和程序采取反向工程手段进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、技术文档、客户端至服务器端的数据、服务器数据）进行复制、修改、编译、整合或篡改，不得修改或增减矢安科技系统的功能。
          </li>
        </ul>
        <div className="title">六、个人信息保护</div>
        <ul>
          <li>
            6.1
            您知悉并同意，在为您提供本产品/服务的过程中，矢安科技可能会使用您业已授权的个人信息（即能够独立或与其他信息结合后识别用户身份的信息，包括但不限于姓名、电话号码、位置信息、浏览行为等），以便向您提供更好的服务。与此同时，矢安科技可能会与相关合作伙伴共享您的部分个人信息。矢安科技承诺，上述使用及共享仅出于合法、正当、必要、特定、明确的目的，并且仅限于与提供本服务相关的个人信息，合作伙伴亦无权将共享的个人信息用于任何其他用途。
          </li>
          <li>
            6.2
            矢安科技公布的《矢安科技隐私政策》，同样适用于本协议项下服务，并且视为您与矢安科技就个人信息方面达成的隐私保护协议。如该隐私保护协议与本协议不一致的，以本协议为准。本协议未未涵盖的内容，以《矢安科技隐私政策》的内容为准。
          </li>
        </ul>
        <div className="title">七、未成年人保护</div>
        <ul>
          <li>
            7.1
            若您是未满18周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下认真阅读本协议后，方可使用本产品/服务，并应遵守《全国青少年网络文明公约》，避免沉迷虚拟的网络空间，养成良好上网习惯。若未成年人用户违反法律法规、本协议内容，则未成年人及其监护人应依照法律规定承担因此而可能引起的全部法律责任。
          </li>
          <li>
            7.2
            矢安科技重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并在监护人指导时正确使用本服务。
          </li>
          <li>
            7.3
            为更好的保护未成年人隐私权益，矢安科技提醒您慎重发布包含未成年人素材的内容，一经发布，即视为您同意本服务展示未成年人的信息、肖像、声音等，且允许矢安科技依据本协议使用、处理该等与未成年人相关的内容，由此引起的后果和责任由您承担。
          </li>
        </ul>
        <div className="title">八、知识产权</div>
        <ul>
          <li>
            8.1
            矢安科技产品/服务所涉及的著作权、专利权、商标权及其他知识产权均由矢安科技合法拥有，受法律保护，但注明引用第三方的内容除外。未经本矢安科技或第三方书面授权，任何人不得将本网站上的任何内容以任何方式进行复制、经销、翻印、播放、以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用。
          </li>
          <li>
            8.2
            您不得出租、出借、拷贝、仿冒、复制或修改矢安科技技术成果，不得将矢安科技提供的软件、服务等技术成果用于其他商业目的，不得以任何方式取得矢安科技享有知识产权的目标程序或源代码。
          </li>
          <li>8.3 尊重知识产权是您应尽的义务，如有违反，您需要承担损害赔偿责任。</li>
        </ul>
        <div className="title">九、违约责任</div>
        <ul>
          <li>
            9.1
            如果矢安科技有理由认为您的行为违反或可能违反本协议的，矢安科技可独立自行进行判断并处理，且有权在不事先通知的情况下根据情节酌情采取以下措施：（1）预先警示、拒绝发布；（2）对相应内容信息进行删除、屏蔽处理；（3）短期、长期中止向您提供部分或全部服务；（4）纳入平台不良违法信息名单、黑名单；（5）注销您的账户，终止向您提供服务；（6）移交司法机关处理。
          </li>
          <li>
            9.2
            对于您的违约、侵权或违法行为，引起第三方投诉或诉讼索赔的，您应当自行处理并承担全部可能由此引起的法律责任。因您的违法、侵权或违约等行为导致矢安科技及其关联矢安科技向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿因此遭受的全部损失。矢安科技未及时采取行动的，并不表明对您上述行为的默认、认可，并不表明矢安科技无权随时追究法律责任，亦不表明矢安科技放弃就任何后继或类似的事件采取动的权利。
          </li>
        </ul>
        <div className="title">十、责任限制</div>
        <ul>
          <li>
            10.1
            您理解并同意，鉴于互联网和/或移动互联网服务的特殊性在试用、使用网站及矢安科技提供的产品/服务的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，矢安科技应及时与相关单位配合进行修复，但是由此给您造成的损失（包括但不限于财产、收益、数据资料等方面的损失或其它无形损失）矢安科技将予以免责。
          </li>
          <li className="directory">
            10.1.1 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素。
          </li>
          <li className="directory">
            10.1.2 因电力供应故障、通讯网络故障等公共服务因素或第三人因素。
          </li>
          <li className="directory">
            10.1.3
            在矢安科技已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
          </li>
          <li className="directory">
            10.1.4 您操作不当或您的电脑软件、系统、硬件和通信线路出现故障。
          </li>
          <li className="directory">
            10.1.5
            由于计算机病毒、木马、其他恶意程序、黑客攻击等意外原因而造成产品/服务的中段或延迟。
          </li>
          <li className="directory">
            10.1.6 其他非矢安科技过错、矢安科技无法控制或合理预见的情形。
          </li>
          <li>
            10.2
            您理解并同意，矢安科技提供的服务是按照现有技术和条件所能达到的现状提供的。矢安科技将尽最大努力确保服务的连贯性和安全性，但矢安科技不能保证其所提供的服务毫无瑕疵。所以您也同意，即使矢安科技提供的服务存在瑕疵，但若上述瑕疵是当时技术水平所无法避免的，其将不被视为矢安科技违约，双方应友好协作共同解决问题。
          </li>
          <li>
            10.3
            您理解并同意，矢安科技对于您自网站或产品/服务而获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯（以下统称“信息”），除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在接受服务时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，矢安科技均不对任何此等内容承担任何责任。无论何种原因，矢安科技不对任何非与矢安科技直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。
          </li>
        </ul>
        <div className="title">十一、通知和送达</div>
        <ul>
          <li>
            11.1
            您应当保证和维持资料的有效性，您的资料若存在虚假、无效等任何可能导致您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，由您自行承担相应责任。
          </li>
          <li>11.2 您应当根据矢安科技公布的联系方式向矢安科技发送通知，双方另有约定除外。</li>
          <li>
            11.3
            矢安科技可以不定期以网页公告、电子邮件、手机短信、站内信、即时通讯工具等方式中的1种或多种向您发送与网站产品/服务有关的业务通知、服务提示、验证消息等各种业务通知。
          </li>
          <li>11.4 各方均应保证其联系方式真实、有效，通知自发送之日视为已送达收件人。</li>
        </ul>
        <div className="title">十二、条款的更新和终止</div>
        <ul>
          <li>
            12.1
            为更好地提升用户体验及服务，矢安科技有权对产品/服务（包括但不限于软件修改、升级、功能强化、开发新服务、软件替换等）进行不定期更新，亦会适时对本协议条款及相应的服务规则内容进行变更/修订，并通过网页公告、电子邮件、站内信、短信等方式予以公告或通知；如您选择不作更新，本服务的部分功能将受到限制或不能正常使用；若您在本协议条款内容变更后继续使用网站及矢安科技提供的产品/服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。
          </li>
          <li>12.2 在您的账户注销或经双方协商一致终止网站服务的，本协议条款终止。</li>
        </ul>
        <div className="title">十三、配套规则及协议</div>
        <div className="text">
          为了您更好地使用网站及相应服务，您还需要阅读并遵守《隐私政策》以及矢安科技公示的其他规则，请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制服务方责任的条款、隐私保护政策、帐号规则、法律适用和争议解决条款（包括管辖条款）。前述协议或规则的部分条款被认定无效的，不影响其他内容的效力。
        </div>
        <div className="title">十四、法律适用与争议解决</div>
        <ul>
          <li>
            14.1
            本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
          </li>
          <li>
            14.2
            因本协议产生之争议，双方应首先协商解决；双方未能以诚意协商解决的，任何一方均应将纠纷或争议提交上海仲裁委员会按照其现行仲裁规则进行仲裁。
          </li>
          <li>
            14.3
            本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
          </li>
        </ul>
        <div className="title">十五、其他</div>
        <ul>
          <li>15.1 本协议中的标题仅为方便及阅读而设，并不影响本协议中任何规定的含义或解释。</li>
          <li>
            15.2
            您和矢安科技均是独立的主体，在任何的情况下本协议不构成矢安科技对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
          </li>
          <li>15.3 本协议解释权与修改权由矢安科技所有。</li>
        </ul> */}
      </LoginContainer>
    </ListContainer>
  )
}

const LoginContainer = styled.div`
  height: 570px;
  padding-right: 40px;
  overflow-y: scroll;
  ul,
  ol,
  li {
    list-style: none;
    margin: 8px 0;
    line-height: 21px;
    padding: 0;
  }
  .topic {
    width: 32px;
    height: 16px;
    font-size: 16px;
    width: 100%;
    font-weight: 600;
    text-align: center;
    color: #333333;
    line-height: 24px;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    width: calc(100% - 20px);
    margin-bottom: 0;
  }
  .title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
  }
  .second-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 21px;
  }
  .directory {
    font-size: 12px;
    margin-left: 10px;
  }
`

const ListContainer = styled(Scrollbars)``
